import React, {useState, useEffect, useContext} from 'react';
import {AuthContext} from "../../../config/AuthContext";
import {Button, Col, Form, Input, Modal, Row, Select, TimePicker} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {User} from "../../../model/root/User";
import dayjs from "dayjs";
import ControlHorari from "../../../model/root/ControlHorari";
import toast, { Toaster } from 'react-hot-toast';
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';
import {GetUsuaris} from "../../../dao/root/GetUsuaris";
import {GetLlocTreball} from "../../../dao/root/GetLlocTreball";
import LlocTreball from '../../../model/root/LlocTreball';
import {PostControlHorari} from "../../../dao/root/PostControlHorari";
import {GetHoraris} from "../../../dao/root/GetHoraris";


const { Option } = Select;

interface IngredientModalProps {
    element: ControlHorari;
    visible: boolean;
    onClose: (value: boolean) => void;
    update: boolean;
}

const ControlHorariAdminModal: React.FC<IngredientModalProps> = ({
        element, visible, onClose, update }) => {

    const [form] = Form.useForm();
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [usuaris, setUsuaris] = useState<User[]>([]);
    
    const format = 'HH:mm';
    const [options2, setOptions2] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);
    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
            label: "",
            value: ""
        }]);
    const [options3, setOptions3] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    useEffect(() => {
        if (!visible) return;

        if (update && element.empresa) {
            // Editando → cargar empresas + todo lo relacionado con la empresa del elemento
            loadDataAndSetForm(element.empresa);
        } else {
            // Creando → solo cargar las empresas, el resto se carga al seleccionar empresa
            loadEmpresas();
        }
    }, [visible]);
    
    const loadEmpresas = async () => {
        try {
            const dadesEmpresas = await GetEmpresas(1, page);
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error al cargar empresas:", error);
            setDadesEmpresa([]);
        }
    };
    

    const loadDataAndSetForm = async (empresa: string) => {
        try {
            const dadesEmpresas = await GetEmpresas(1, page);
            setDadesEmpresa(dadesEmpresas || []);

            // Cargar todos los datos necesarios
            const [usuarisData, llocsData, horarisData] = await Promise.all([
                GetUsuaris(empresa),
                GetLlocTreball(empresa),
                GetHoraris(empresa)
            ]);

            setUsuarisOptions(usuarisData?.usuaris || []);
            setLlocsOptions(llocsData || []);
            setHorariOptions(horarisData || []);

            // Establecer los valores en el formulario
            form.setFieldsValue({
                ...element,
                id_usuario: element.id_usuario?.toString(),
                id_lloc: element.id_lloc?.toString(),
                id_horari: element.id_horari?.toString(),
                entrada: element.entrada && dayjs(element.entrada, format).isValid()
                    ? dayjs(element.entrada, format)
                    : null,
                sortida: element.sortida && dayjs(element.sortida, format).isValid()
                    ? dayjs(element.sortida, format)
                    : null,
            });

            // También actualizamos estado si lo usas en otras partes
            setIdUsuari(element.id_usuario);
            setIdLloc(element.id_lloc);

        } catch (error) {
            console.error("Error al cargar datos:", error);
        }
    };



    const handleEmpresaChange = async (empresa: string) => {
        form.setFieldValue("empresa", empresa);
  
        const dades = await GetUsuaris(empresa);
        setUsuarisOptions(dades?.usuaris || []);
    
        // Cargar llocs de treball
        const llocTreballsData = await GetLlocTreball(empresa);
        setLlocsOptions(llocTreballsData || []);
        
        //cargar horari
        const horarisData = await GetHoraris(empresa);
        setHorariOptions(horarisData || []);
    };

    function setLlocsOptions(llocs: LlocTreball[]) {
        if (llocs && llocs?.length) {
            const options = llocs.map(lloc => ({
                label: `${lloc.nom}`,
                value: lloc.id + ""
            }));
            setOptions2(options);
        }
    }
    function setUsuarisOptions(usuaris: User[]) {
            if (usuaris && usuaris?.length) {
                const options = usuaris.map(contact => ({
                    label: `${contact.nom}`,
                    value: contact.id + ""
                }));
                setOptions(options);
            }
    }

    function setHorariOptions(horaris: any[]) {
        if (horaris && horaris?.length) {
            const options = horaris.map(horari => ({
                label: `${horari.nom}: ${horari.entrada} - ${horari.sortida} `,
                value: horari.id + ""
            }));
            setOptions3(options);
        }
    }
    
    const handleSubmit = async () => {
        const formData = form.getFieldsValue();
        
        formData.entrada = formData.entrada ? dayjs(formData.entrada).format('HH:mm') : null;
        formData.sortida = formData.sortida ? dayjs(formData.sortida).format('HH:mm') : null;
        
        const empresaSeleccionada = form.getFieldValue('empresa');
        await PostControlHorari(formData, empresaSeleccionada);
        onClose(true);
        
        
    };


    const [idLloc, setIdLloc] = useState(element.id_lloc);
    const [idUsuari, setIdUsuari] = useState(element.id_usuario);

    const filterOption = (input: string, options?: { label: string; value: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <>
            <Toaster />
            <Modal
                title="Crear/Editar Control Horari"
                open={visible}
                onCancel={handleCancel}
                footer={[
                ]}
                width={'40%'}
            >
                <Form form={form} initialValues={element} onFinish={handleSubmit}>
                    <Form.Item 
                        label="Empresa" 
                        name="empresa" 
                        rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                    >
                        <Select
                            disabled={update}
                            placeholder="Selecciona una empresa"
                            onChange={handleEmpresaChange}
                        >
                            {Array.isArray(empresas) && empresas.map(value =>
                                <Option key={value.id} value={value.datasource}>
                                    {value.nomEmpresa}
                                </Option>
                            )}
                        </Select>
                        </Form.Item>
                    {form.getFieldValue("empresa") && (  
                         <>  
                            
                            <Row gutter={[16, 16]}>
                                <Col span={3}>
                                    <Form.Item label="ID" name="id">
                                        <Input disabled/>
                                    </Form.Item>
                                </Col>    
                                <Col span={12}>
                                    <Form.Item label="Nom usuari" name="id_usuario" required>
                                        <Select disabled={update}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={filterOption}
                                                options={options}
                                               
                                        />
                                    </Form.Item>
                                </Col>
                                <Col flex="auto">
                                    <Form.Item label="Estado" name="estat" required>
                                        <Select>
                                            <option value={0}>actiu</option>
                                            <option value={-1}>inactiu</option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>    
                        <Row gutter={[16, 16]}>
                            <Col span={15}>
                                <Form.Item label="Horari" name="id_horari" required>
                                    <Select
                                        showSearch
                                        placeholder="Selecciona l'horari"
                                        optionFilterProp="children"
                                        filterOption={filterOption}
                                        options={[
                                            { label: 'Personalitzar horari', value: '0' },
                                            ...options3
                                        ]}
                                        onChange={(value) => {
                                            form.setFieldValue("id_horari", value);
                                            setIdLloc(value); // si aún lo usas para algo más
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                    <Col flex="auto">
                        <Form.Item label="Lloc" name="id_lloc" required>
                            <Select
                                showSearch
                                placeholder="Selecciona Lloc de treball"
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={options2}
                                onChange={(text) => {
                                    setIdLloc(text);
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                 {form.getFieldValue("id_horari") === "0" && (
                            <>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Form.Item
                                        label="Entrada"
                                        name="entrada"
                                    >
                                        <TimePicker format="HH:mm"  />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label="Sortida"
                                        name="sortida"
                                    >
                                        <TimePicker format="HH:mm"  />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )}
                
                        </> 
                        )}

                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
                </Form>
            </Modal>
        </>
    );
};

export default ControlHorariAdminModal;
